import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

import SearchAnyProductIcon from '~/components/SearchAnyProductIcon'
import { mountUrl, replaceImagePath } from '~/utils'

const useStyles = makeStyles({
  notFound: {
    border: '1px solid #c4c4c4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export function ImageProduct({ product, dimensions: { width = 0, height = 0 } }) {
  const classes = useStyles()
  const imageCurrentProduct = replaceImagePath(product)

  return imageCurrentProduct ? (
    <img
      src={mountUrl(imageCurrentProduct, { height: 100 })}
      alt={product.name}
      width={width}
      height={height}
      loading="lazy"
      style={{ border: '1px solid #c4c4c4', marginRight: 4 }}
    />
  ) : (
    <Grid style={{ width, height }} className={classes.notFound}>
      <SearchAnyProductIcon />
    </Grid>
  )
}

ImageProduct.propTypes = {
  product: PropTypes.object,
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}
